export default {
  methods: {
    isDevelopment() {
      const hostName = document.location.hostname;
      return hostName === "localhost" || hostName === "127.0.0.1" || hostName === "flew-dev.web.app";
    },
  }
}
